<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 503.131 503.131"
>
  <circle cx="251.565" cy="332.312" r="151.158" fill="#55ff9a" />
  <path
    d="M251.565 181.169c83.48 0 151.142 67.663 151.142 151.142 0 83.464-67.663 151.127-151.142 151.127"
    fill="#1ddd6b"
  />
  <path
    d="M251.565 503.131c-94.2 0-170.835-76.635-170.835-170.819 0-94.2 76.635-170.835 170.835-170.835S422.4 238.111 422.4 332.312c0 94.184-76.635 170.819-170.835 170.819zm0-302.269c-72.476 0-131.45 58.967-131.45 131.45 0 72.468 58.967 131.434 131.45 131.434s131.45-58.959 131.45-131.434-58.974-131.45-131.45-131.45z"
    fill="#00ad73"
  />
  <path
    d="M251.565 199.546c-10.878 0-19.692-8.814-19.692-19.692V19.692C231.873 8.814 240.687 0 251.565 0s19.692 8.814 19.692 19.692v160.154c.001 10.878-8.814 19.7-19.692 19.7z"
    fill="#00ad73"
  />
  <path
    d="M325.734 105.677H177.412c-10.894 0-19.708-8.814-19.708-19.692s8.814-19.692 19.708-19.692h148.322c10.878 0 19.692 8.814 19.692 19.692s-8.814 19.692-19.692 19.692z"
    fill="#00ad73"
  />
  <circle cx="290.272" cy="330.335" r="8.365" fill="#55ff9a" />
  <circle
    cx="322.261"
    cy="330.335"
    r="8.365"
    fill="#55ff9a"
  />
  <path
    d="M362.646 330.335c0 4.624-3.757 8.365-8.381 8.365-4.6 0-8.357-3.749-8.357-8.365s3.757-8.365 8.357-8.365c4.623-.001 8.381 3.741 8.381 8.365z"
    fill="#55ff9a"
  />
  <path
    d="M298.748 136.2a19.595 19.595 0 0 1 5.782-13.926l34.816-34.816-34.816-34.817c-7.711-7.696-7.711-20.157 0-27.845 7.68-7.696 20.141-7.696 27.829 0l48.742 48.742c7.696 7.696 7.696 20.157 0 27.845l-48.742 48.742c-7.696 7.696-20.157 7.696-27.829 0a19.579 19.579 0 0 1-5.782-13.925zM204.398 38.723a19.645 19.645 0 0 1-5.766 13.926l-34.816 34.816 34.816 34.816c7.696 7.696 7.696 20.157 0 27.845-7.696 7.688-20.157 7.696-27.845 0l-48.742-48.742c-7.696-7.696-7.696-20.157 0-27.845l48.742-48.742c7.696-7.696 20.157-7.696 27.845 0a19.658 19.658 0 0 1 5.766 13.926z"
    fill="#00ad73"
  />
</svg>
